import { initI18n } from '@/lib/i18n';

/**
 * BP-11 §13's `mobile.*` copy.
 *
 * `notifications.*` lives with its feature package
 * (`features/messaging/devices/strings.ts`), and BP-21 took `tryOn.*` with
 * it when it replaced R10's placeholder with a real screen in
 * `features/tryon`. What is left belongs to screens the client app owns
 * outright and has no feature behind it.
 *
 * **The update screen names the version the person has.** "Update required"
 * with nothing else is indistinguishable from a bug, and the one thing that
 * makes it credible — and lets support ask one question instead of five —
 * is the build number already on the screen.
 */
export const MOBILE_NAMESPACE = 'mobile';

export const mobileStrings = {
  // R9: the moment between a tapped link and the screen behind it. It is a
  // `GET /me`, and on a cold start over a slow connection it is long enough
  // that a blank screen reads as a broken link.
  deepLink: { opening: 'Opening your booking…' },
  update: {
    title: 'Update 26AD to carry on',
    body: 'This version is too old to talk to the salon. Updating takes a moment and keeps your bookings.',
    installed: 'You have version {{version}}.',
    play: 'Open Google Play',
    appStore: 'Open the App Store',
  },
} as const;

/** Add the namespace to the shared i18next instance. Idempotent. */
export function registerMobileStrings(): void {
  initI18n().addResourceBundle('en', MOBILE_NAMESPACE, mobileStrings, true, false);
}

registerMobileStrings();
